module.exports = __webpack_public_path__ + "static/media/trunk_s.e34d7c65.svg";